import Vue from 'vue'

const bus = new Vue()
let pendingRequest = null

export function requestEmailVerification(challenge) {
    if (pendingRequest != null) {
        return pendingRequest.promise
    }

    let resolveRequest
    const promise = new Promise(resolve => {
        resolveRequest = resolve
    })
    pendingRequest = {promise, resolve: resolveRequest}
    bus.$emit('open', challenge || {})
    return promise
}

export function finishEmailVerification(verified) {
    if (pendingRequest == null) {
        return
    }
    pendingRequest.resolve(verified)
    pendingRequest = null
}

export default bus
